import { Controller } from 'stimulus'

export default class extends Controller {
  changePage(e) {
    e.preventDefault()
    e.currentTarget.dispatchEvent(new CustomEvent('changePage', { bubbles: true }))
  }
}
